import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styles from '../index.module.scss';
import isEmpty from 'lodash/isEmpty';
import Section from 'components/Section';
import DetailGeneralInfo from 'components/DetailGeneralInfo';
import {
  getSecurityCompanyBillingInfo,
  getSecurityCompanyDetail,
} from 'reducers/securityCompany';
import { transform } from 'utils/DataTransform/SecurityCompanies/securityCompanyAccountInfo';
import Loader from 'components/Loader';

const getBillingData = data => {
  if (!isEmpty(data)) {
    //transform the data to translate.
    return <DetailGeneralInfo display="block" data={data} />;
  } else {
    return <Loader outline />;
  }
};

const SubscriptionInfo = ({
  securityCompanyBillingInfo,
  securityCompanyDetail,
}) => {
  const transformedData = transform(
    securityCompanyDetail,
    securityCompanyBillingInfo,
  );

  const haveCard = isEmpty(securityCompanyBillingInfo)
    ? false
    : securityCompanyBillingInfo.paymentMethod.last4;

  return (
    <>
      <div className={styles.infoPanel}>
        {haveCard ? (
          <>
            <Section
              text="Subscription Overview"
              className={styles.planSection}
              expandable={false}
              editable={false}
            >
              {getBillingData(transformedData.currentPlan)}
            </Section>
          </>
        ) : (
          <Section
            text="Subscription Overview"
            className={styles.planSection}
            expandable={false}
            editable={false}
          ></Section>
        )}
      </div>
    </>
  );
};

SubscriptionInfo.propTypes = {
  securityCompanyProfile: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.bool,
  ]),
  securityCompanyBillingInfo: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.bool,
  ]),
  securityCompanyBillingInfoRaw: PropTypes.object,
  securityCompanyImage: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  showEditCompany: PropTypes.bool,
  toggleModal: PropTypes.func,
  fetchBillingInfo: PropTypes.func,
  companyId: PropTypes.string,
  fetchCompanyDetails: PropTypes.func,
  securityCompanyDetail: PropTypes.object,
};

const mapStateToProps = state => ({
  securityCompanyDetail: getSecurityCompanyDetail(state),
  securityCompanyBillingInfo: getSecurityCompanyBillingInfo(state),
});

export default connect(mapStateToProps, null)(SubscriptionInfo);
